import request from '@/utils/request'


// 查询企业认证列表
export function listCertification(query) {
  return request({
    url: '/enterprise/enterprise-certification/list',
    method: 'get',
    params: query
  })
}

// 查询企业认证分页
export function pageCertification(query) {
  return request({
    url: '/enterprise/enterprise-certification/page',
    method: 'get',
    params: query
  })
}

// 查询企业认证详细
export function getCertification(data) {
  return request({
    url: '/enterprise/enterprise-certification/detail',
    method: 'get',
    params: data
  })
}

// 新增企业认证
export function addCertification(data) {
  return request({
    url: '/enterprise/enterprise-certification/add',
    method: 'post',
    data: data
  })
}

// 修改企业认证
export function updateCertification(data) {
  return request({
    url: '/enterprise/enterprise-certification/edit',
    method: 'post',
    data: data
  })
}

// 删除企业认证
export function delCertification(data) {
  return request({
    url: '/enterprise/enterprise-certification/delete',
    method: 'post',
    data: data
  })
}
